import { c as _c } from "react/compiler-runtime";
import { getDefaultLocale } from '@onefootprint/core';
import { postHostedIdentifySessionKbaMutation } from '@onefootprint/fetch-hosted';
import type { IdentifyRequirementLogin } from '@onefootprint/request-types';
import { Button, Form, PageShell } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { isSessionExpired } from '@/idv2/features/identify/handle-session-expired';
import { logIdentifyError } from '@/idv2/features/identify/log-identify-error';
import { renderScrubbedText } from '@/idv2/features/identify/render-scrubbed-text';
import { useVaultErrorMessage } from '@/idv2/features/identify/use-vault-error-message';
export type PhoneKbaChallengeProps = {
  loginRequirement: IdentifyRequirementLogin;
  onboardingSessionToken: string;
  defaultPhone?: string;
  onSuccess: () => void;
  onError?: (error: unknown) => void;
  headerIcon?: ReactNode;
};
type PhoneKbaFormData = {
  phone: string;
};
export const PhoneKbaChallenge = t0 => {
  const $ = _c(59);
  const {
    loginRequirement,
    onboardingSessionToken,
    defaultPhone,
    onSuccess,
    onError,
    headerIcon
  } = t0;
  const {
    t,
    i18n
  } = useTranslation("idv2");
  let t1;
  if ($[0] !== i18n.language) {
    t1 = getDefaultLocale(i18n.language);
    $[0] = i18n.language;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const locale = t1;
  const getVaultErrorMessage = useVaultErrorMessage();
  let t2;
  let t3;
  if ($[2] !== onboardingSessionToken) {
    const headers = {
      "X-Fp-Authorization": onboardingSessionToken
    };
    t2 = useMutation;
    t3 = postHostedIdentifySessionKbaMutation({
      headers
    });
    $[2] = onboardingSessionToken;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  const mutation = t2(t3);
  const t4 = defaultPhone ?? "";
  let t5;
  if ($[5] !== t4) {
    t5 = {
      defaultValues: {
        phone: t4
      }
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const methods = useForm(t5);
  const t6 = loginRequirement.user?.scrubbedPhone ?? "";
  let T0;
  let handleSubmit;
  let t7;
  let t8;
  let t9;
  if ($[7] !== getVaultErrorMessage || $[8] !== headerIcon || $[9] !== methods || $[10] !== mutation || $[11] !== onError || $[12] !== onSuccess || $[13] !== t || $[14] !== t6) {
    const lastFourDigits = t6.slice(-4).replace(/\*/g, "\u2022");
    let t10;
    if ($[20] !== getVaultErrorMessage || $[21] !== methods || $[22] !== mutation || $[23] !== onError || $[24] !== onSuccess) {
      t10 = async data => {
        ;
        try {
          await mutation.mutateAsync({
            body: {
              "id.phone_number": data.phone
            }
          });
          onSuccess();
        } catch (t11) {
          const error = t11;
          if (isSessionExpired(error)) {
            onError?.(error);
            return;
          }
          logIdentifyError("phone-kba-challenge", error);
          const message = getVaultErrorMessage(error, "id.phone_number");
          if (message) {
            methods.setError("phone", {
              message
            });
          }
        }
      };
      $[20] = getVaultErrorMessage;
      $[21] = methods;
      $[22] = mutation;
      $[23] = onError;
      $[24] = onSuccess;
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    handleSubmit = t10;
    T0 = PageShell;
    t7 = headerIcon;
    if ($[26] !== t) {
      t8 = t(_temp);
      $[26] = t;
      $[27] = t8;
    } else {
      t8 = $[27];
    }
    t9 = renderScrubbedText(t(_temp2, {
      digits: lastFourDigits
    }));
    $[7] = getVaultErrorMessage;
    $[8] = headerIcon;
    $[9] = methods;
    $[10] = mutation;
    $[11] = onError;
    $[12] = onSuccess;
    $[13] = t;
    $[14] = t6;
    $[15] = T0;
    $[16] = handleSubmit;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[15];
    handleSubmit = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t10;
  if ($[28] !== handleSubmit || $[29] !== methods) {
    t10 = methods.handleSubmit(handleSubmit);
    $[28] = handleSubmit;
    $[29] = methods;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t) {
    t11 = t(_temp3);
    $[31] = t;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t) {
    t12 = t(_temp4);
    $[33] = t;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t12) {
    t13 = {
      required: t12
    };
    $[35] = t12;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== locale || $[38] !== t11 || $[39] !== t13) {
    t14 = <Form.Tel label={t11} name="phone" locale={locale} rules={t13} />;
    $[37] = locale;
    $[38] = t11;
    $[39] = t13;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  const t15 = mutation.isPending;
  const t16 = mutation.isPending;
  let t17;
  if ($[41] !== t) {
    t17 = t(_temp5);
    $[41] = t;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== mutation.isPending || $[44] !== t17) {
    t18 = <Button type="submit" variant="primary" fullWidth={true} size="large" loading={t15} disabled={t16}>{t17}</Button>;
    $[43] = mutation.isPending;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t10 || $[47] !== t14 || $[48] !== t18) {
    t19 = <form onSubmit={t10} className="flex flex-col gap-4 w-full">{t14}{t18}</form>;
    $[46] = t10;
    $[47] = t14;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== methods || $[51] !== t19) {
    t20 = <FormProvider {...methods}>{t19}</FormProvider>;
    $[50] = methods;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  let t21;
  if ($[53] !== T0 || $[54] !== t20 || $[55] !== t7 || $[56] !== t8 || $[57] !== t9) {
    t21 = <T0 headerIcon={t7} title={t8} subtitle={t9}>{t20}</T0>;
    $[53] = T0;
    $[54] = t20;
    $[55] = t7;
    $[56] = t8;
    $[57] = t9;
    $[58] = t21;
  } else {
    t21 = $[58];
  }
  return t21;
};
function _temp($) {
  return $.identify.kba.title;
}
function _temp2($_0) {
  return $_0.identify.kba.subtitle;
}
function _temp3($_1) {
  return $_1.identify.phone.label;
}
function _temp4($_2) {
  return $_2.identify.phone.requiredError;
}
function _temp5($_3) {
  return $_3.identify.phone.continue;
}